module.exports = "/_next/static/images/question-cfc0bfea4456eed13a5bdc2949406caa.svg";